<template>
  <div class="certificate-inquiry">
    <div class="inquiry-container">
      <h1 class="title">证书查询</h1>
      
      <!-- 通过姓名手机号查询 -->
      <div class="query-section">
        <h3 class="section-title">通过姓名手机号查询</h3>
        <div class="form-group">
          <el-input
            v-model="namePhoneForm.name"
            placeholder="姓名"
            class="input-field"
          />
          <el-input
            v-model="namePhoneForm.phone"
            placeholder="手机号"
            class="input-field"
          />
          <el-button
            type="primary"
            class="query-btn"
            @click="queryByNamePhone"
          >
            查询
          </el-button>
        </div>
      </div>

      <!-- 通过证书编号查询 -->
      <div class="query-section">
        <h3 class="section-title">通过证书编号查询</h3>
        <div class="form-group">
          <el-input
            v-model="certificateForm.number"
            placeholder="证书编号"
            class="input-field certificate-input"
          />
          <el-button
            type="primary"
            class="query-btn"
            @click="queryByCertificateNumber"
          >
            查询
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Category from '@/api'

export default {
  name: 'CertificateInquiry',
  data() {
    return {
      namePhoneForm: {
        name: '',
        phone: ''
      },
      certificateForm: {
        number: ''
      }
    }
  },
  methods: {
    async queryByNamePhone() {
      if (!this.namePhoneForm.name) {
        this.$message.warning('请输入姓名')
        return
      }
      if (!this.namePhoneForm.phone) {
        this.$message.warning('请输入手机号')
        return
      }
      
      try {
        const res = await Category.queryByMember({
          name: this.namePhoneForm.name,
          mobile: this.namePhoneForm.phone
        })
        
        if (res.code === 2000) {
          if (res.data && res.data.length > 0) {
            this.$message.success('查询成功')
            console.log('查询结果:', res.data)
            // TODO: 处理查询结果，展示证书列表
          } else {
            this.$message.warning('未查询到相关证书')
          }
        } else {
          this.$message.error(res.msg || '查询失败')
        }
      } catch (error) {
        console.error('查询失败:', error)
        this.$message.error('查询失败，请稍后重试')
      }
    },
    
    async queryByCertificateNumber() {
      if (!this.certificateForm.number) {
        this.$message.warning('请输入证书编号')
        return
      }
      
      try {
        const res = await Category.queryByCode({
          certificate_no: this.certificateForm.number
        })
        
        if (res.code === 2000) {
          if (res.data && res.data.length > 0) {
            this.$message.success('查询成功')
            console.log('查询结果:', res.data)
            // TODO: 处理查询结果，展示证书详情
          }
        } else {
          this.$message.error(res.msg || '未查询到相关证书')
        }
      } catch (error) {
        console.error('查询失败:', error)
        this.$message.error('查询失败，请稍后重试')
      }
    }
  }
}
</script>

<style scoped>
.certificate-inquiry {
  min-height: 100vh;
  padding: 40px 20px;
}

.inquiry-container {
  max-width: 1000px;
  margin: 0 auto;
}

.title {
  text-align: center;
  font-size: 32px;
  color: #333;
  margin-bottom: 10px;
  font-weight: normal;
  position: relative;
  padding-bottom: 15px;
}

.title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: #1ba9d6;
}

.query-section {
  background: #fff;
  padding: 40px;
  margin-top: 40px;
  border-radius: 4px;
}

.section-title {
  text-align: center;
  font-size: 16px;
  color: #666;
  margin-bottom: 30px;
  font-weight: normal;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
}

.input-field {
  width: 580px;
}

.certificate-input {
  width: 580px;
}

.query-btn {
  width: 200px;
  height: 40px;
  background: #1ba9d6;
  border-color: #1ba9d6;
  font-size: 16px;
}

.query-btn:hover {
  background: #1596bf;
  border-color: #1596bf;
}

::v-deep .el-input__inner {
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
}
</style>
